<template>
  <div class="UnbilledWorkOrderComp">
    <div class="cardTabs">
      <div class="cardTabsHeader">
        <label
          id="tab1"
          class="tabLabel active"
          @click="switchTab('tab1', 'content1')"
        >{{ $t('analysisRequests.labels.labWorkOrder') }}</label>
        <label
          id="tab2"
          class="tabLabel active"
          @click="switchTab('tab2', 'content2')"
        >{{ $t('siteDashboard.fieldServiceWo') }}</label>
      </div>
      <div class="cardTabsContent">
        <div
          id="content1"
          class="cardTabsContentItem active"
        >
          <LabWorkOrder
            :workOrderType="tabActive"
          />
        </div>
        <div
          id="content2"
          class="cardTabsContentItem"
        >
          <FieldServiceWorkOrder
            :workOrderType="tabActive"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LabWorkOrder from '@/views/sites/siteDashboard/components/UnbilledWorkOrders/LabWorkOrder.vue';
import FieldServiceWorkOrder from '@/views/sites/siteDashboard/components/UnbilledWorkOrders/FieldServiceWorkOrder.vue';

export default {
    name: 'UnbilledWorkOrderComp',
    components: { FieldServiceWorkOrder, LabWorkOrder },
    data() {
        return {
            tabActive: '',
        };
    },
    mounted() {
        this.switchTab('tab1', 'content1');
    },
    methods: {
        switchTab(tabId, contentId) {
            document.getElementsByClassName('tabLabel').forEach(tab => {
                tab.classList.remove('active');
            });
            document.getElementsByClassName('cardTabsContentItem').forEach(content => {
                // eslint-disable-next-line no-param-reassign
                content.style.display = 'none';
            });
            document.getElementById(tabId).classList.add('active');
            document.getElementById(contentId).style.display = 'block';
            this.tabActive = tabId;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/components/unbilliedWoStyle";
</style>
